<!-- src/components/UnderConstruction.vue -->
<template>
    <div class="under-construction">
      <div class="content">
        <div class="icon">🚧</div>
        <h1>Page Under Construction</h1>
        <p>We are working to bring this page to you soon!</p>
        <p>Please check back later to see the updates.</p>
        <router-link to="/renegado-privacy-policy" class="privacy-link">View Renegado's Privacy Policy</router-link>
        <br>
        <router-link to="/dioroom-privacy-policy" class="privacy-link">View Dioroom's Privacy Policy</router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UnderConstruction',
  }
  </script>
  
  <style scoped>
  .under-construction {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #1e1e2f; /* Dark background */
    color: #e0e0e0;
    font-family: Arial, sans-serif;
    text-align: center;
  }
  
  .content {
    max-width: 600px;
    padding: 20px;
    border: 1px solid #444;
    border-radius: 12px;
    background: rgba(34, 34, 51, 0.85);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    animation: fadeIn 0.5s ease-in-out;
  }
  
  .icon {
    font-size: 4rem;
    margin-bottom: 1rem;
    animation: bounce 1s infinite;
  }
  
  p {
    font-size: 1.1rem;
    margin: 0.5rem 0;
    line-height: 1.6;
    color: #cfcfcf;
  }
  
  /* Estilos para o link de política de privacidade */
  .privacy-link {
    display: inline-block;
    margin-top: 1rem;
    padding: 10px 20px;
    background-color: #ffcc00;
    color: #1e1e2f;
    text-decoration: none;
    border-radius: 8px;
    font-weight: bold;
    transition: background-color 0.3s ease;
  }
  
  .privacy-link:hover {
    background-color: #ffd700;
  }
  
  /* Fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  /* Bounce animation for the icon */
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
  </style>
  